import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import './lp-1.scss';
import Footer from '../../components/common/Footer';
import {
  fetchRecommendationPaymentStatus,
  RecommendationPayload,
} from '../../api/gsRecommendations';
import HeaderLp from './HeaderLp';

const Lp1PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const uuid = searchParams.get('uuid');
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<RecommendationPayload | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!uuid) {
        setError('Missing recommendation reference.');
        setLoading(false);
        return;
      }

      const { ok, body } = await fetchRecommendationPaymentStatus({ uuid, sessionId });
      if (cancelled) return;

      if (ok && body?.success && body.data) {
        setData(body.data);
      } else {
        setError(body?.error || 'Unable to confirm payment status.');
      }
      setLoading(false);
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [uuid, sessionId]);

  const title =
    data?.paid && !sessionId
      ? 'Payment is already done'
      : data?.paid
        ? 'Thank you — payment received'
        : 'Payment received — confirming…';

  return (
    <main className=" ">
      <HeaderLp />
      {loading && <p>Confirming payment…</p>}

      {!loading && error && (
        <div className='jakarta-font lp-state intro-content'>

          <h1 className="lp-dark-text">We could not confirm your payment</h1>
          <p>{error}</p>
          <p>
            If you were charged, contact <a href="mailto:care@getscanned.me">care@getscanned.me</a>.
          </p>
        </div>
      )}

      {!loading && !error && data && (
        <div className='jakarta-font lp-state intro-content'>
          <h1 className="lp-dark-text">{title}</h1>
          <p>
            {data.first_name ? `Hi ${data.first_name}. ` : ''}
            {data.paid
              ? "We'll let you know if any further step is needed from your end."
              : `Your booking for ${data.service_name || 'your recommended scan'} is being confirmed.`}
            {data.aftercare_first_name
              ? ` ${data.aftercare_first_name} may also be in touch if anything else is required.`
              : ''}
          </p>
          {data.plan_reference && <p>Plan reference: {data.plan_reference}</p>}
          {data.location && <p>Location: {data.location}</p>}
          <Link to="/" className="lp-button lp-primary-button">
            Go to Homepage
          </Link>
        </div>
      )}

      <Footer />
    </main>
  );
};

export default Lp1PaymentSuccess;
